module.exports = __webpack_public_path__ + "img/chromecast.d413cd78.svg";